var cov_2f9ukb7iwi = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Scroll/styles/index.ts",
      hash = "07dd96741c9b3d202278b1ee076a714001ec4d47",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Scroll/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var scrollLess = {};
import genaration from '../../utils/classname';
export var scrollClass = (cov_2f9ukb7iwi.s[0]++, genaration(scrollLess, 'scroll'));